// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__20cAV","file":"styles_file__C4y6G"};